import {ECustomerGender} from './ICustomer';

/**
 * Maps salutation (Mr/Mrs) to SFCC customer gender enum.
 */
export const getGenderFromSalutation = (salutation?: string): ECustomerGender | undefined => {
	if (salutation === 'Mr') {
		return ECustomerGender.MALE;
	}

	if (salutation === 'Mrs') {
		return ECustomerGender.FEMALE;
	}

	if (salutation === '') {
		return ECustomerGender.NO_PREFERENCE;
	}

	return undefined;
};

/**
 * Resolves gender for newsletter/customer payloads: explicit gender wins, else salutation mapping.
 */
export const resolveGenderFromSalutation = (
	gender?: string | number | ECustomerGender,
	salutation?: string,
): ECustomerGender | undefined => {
	if (gender !== undefined && gender !== null && gender !== '') {
		return typeof gender === 'string' ? Number.parseInt(gender, 10) : gender;
	}

	return getGenderFromSalutation(salutation);
};

/**
 * Maps SFCC gender enum to salutation for forms (Mr/Mrs).
 */
export const getSalutationFromGender = (gender?: ECustomerGender | number): string => {
	if (gender === ECustomerGender.MALE) {
		return 'Mr';
	}

	if (gender === ECustomerGender.FEMALE) {
		return 'Mrs';
	}

	return '';
};
